// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../common/Components/IconV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let Link = require("next/link").default;
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let IsNewQueryParam = require("./IsNewQueryParam.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let React = require("@headlessui/react");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarketingProfileMembersListRemoveMutation_graphql = require("../../__generated__/MarketingProfileMembersListRemoveMutation_graphql.bs.js");
let MarketingProfileMembersList_teamMarketingProfile_graphql = require("../../__generated__/MarketingProfileMembersList_teamMarketingProfile_graphql.bs.js");
let MarketingProfileMembersList_member_marketingProfileMember_graphql = require("../../__generated__/MarketingProfileMembersList_member_marketingProfileMember_graphql.bs.js");
let MarketingProfileMembersList_member_menu_marketingProfileMember_graphql = require("../../__generated__/MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.bs.js");

let convertVariables = MarketingProfileMembersListRemoveMutation_graphql.Internal.convertVariables;

let convertResponse = MarketingProfileMembersListRemoveMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = MarketingProfileMembersListRemoveMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MarketingProfileMembersListRemoveMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, MarketingProfileMembersListRemoveMutation_graphql.node, convertResponse, convertWrapRawResponse);

let RemoveMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertFragment = MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MarketingProfileMembersList$Member$Menu$MenuItem(props) {
  let __disabled = props.disabled;
  let disabled = __disabled !== undefined ? __disabled : false;
  return JsxRuntime.jsx(React.Menu.Item, {
    disabled: disabled,
    className: "ui-active:bg-zinc-50 block px-3 py-2 leading-6 rounded",
    children: props.children
  });
}

let MenuItem = {
  make: MarketingProfileMembersList$Member$Menu$MenuItem
};

function MarketingProfileMembersList$Member$Menu(props) {
  let connectionId = props.connectionId;
  let member = RescriptRelay_Fragment.useFragment(MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.node, convertFragment, props.member);
  let match = use();
  let removeMemberMutate = match[0];
  let match$1 = SystemMessages.useSystemMessages();
  let addMessage = match$1.addMessage;
  let addRemoveMemberErrorMessage = () => addMessage(SystemMessages.Message.make(undefined, "error", "There was a problem removing the team member. Please try again.", 5000, undefined, undefined));
  let addMemberNotFoundMessage = () => addMessage(SystemMessages.Message.make(undefined, "warning", "Looks like this team member has already been removed. Please refresh the page.", 5000, undefined, undefined));
  let onRemove = () => {
    removeMemberMutate({
      connectionId: connectionId,
      input: {
        memberId: member.id
      }
    }, undefined, undefined, undefined, (response, errors) => {
      let match = response.removeMarketingProfileMember;
      if (errors !== undefined) {
        return addRemoveMemberErrorMessage();
      }
      if (match === undefined) {
        return addRemoveMemberErrorMessage();
      }
      switch (match.__typename) {
        case "MarketingProfileMemberRemoved" :
          return;
        case "NotFoundError" :
          return addMemberNotFoundMessage();
        case "ProfileSettingsChangedError" :
          return addMessage(SystemMessages.Message.make(undefined, "warning", Stdlib_Option.getOr(match.settingsChangedMessage, "Your profile settings have changed. Refresh this page before saving."), 5000, undefined, undefined));
        case "__unselected" :
          return addRemoveMemberErrorMessage();
      }
    }, _error => addRemoveMemberErrorMessage(), undefined);
  };
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  let match$2 = IsNewQueryParam.use();
  let match$3 = member.publicUrl;
  let tmp;
  let exit = 0;
  if (match$3 !== undefined) {
    if (hasFullProfile) {
      tmp = JsxRuntime.jsx(MarketingProfileMembersList$Member$Menu$MenuItem, {
        children: JsxRuntime.jsxs("a", {
          children: [
            "View member profile",
            JsxRuntime.jsx("span", {
              children: `, ` + member.displayName,
              className: "sr-only"
            })
          ],
          className: "text-zinc-900 hover:text-zinc-900 cursor-pointer",
          href: Scalars.URL.toString(Primitive_option.valFromOption(match$3)),
          target: "_blank"
        })
      });
    } else {
      exit = 1;
    }
  } else if (hasFullProfile) {
    tmp = null;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(MarketingProfileMembersList$Member$Menu$MenuItem, {
      children: JsxRuntime.jsx("span", {
        children: "View member profile (Pro plan only)",
        className: "text-zinc-400 cursor-default"
      }),
      disabled: true
    });
  }
  return JsxRuntime.jsxs(React.Menu, {
    as: "div",
    className: "relative flex-none",
    children: [
      JsxRuntime.jsxs(React.Menu.Button, {
        className: "-m-2.5 block p-2.5 text-zinc-500 hover:text-zinc-900 focus-visible:ring",
        children: [
          JsxRuntime.jsx("span", {
            children: "Open options",
            className: "sr-only"
          }),
          JsxRuntime.jsx(IconV5.make, {
            icon: "three-dots",
            className: "h-4 w-4"
          })
        ]
      }),
      JsxRuntime.jsxs(React.Menu.Items, {
        className: "absolute right-0 z-10 mt-2 w-52 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-zinc-900/5 focus:outline-none py-3 px-2",
        children: [
          tmp,
          JsxRuntime.jsx(MarketingProfileMembersList$Member$Menu$MenuItem, {
            children: JsxRuntime.jsxs(Link, {
              href: `/account/team_marketing_profile/members/` + member.id + `/edit?is_new=` + (
                match$2[0] ? "1" : "0"
              ),
              className: "text-zinc-900 hover:text-zinc-900",
              children: [
                "Edit",
                JsxRuntime.jsx("span", {
                  children: `, ` + member.displayName,
                  className: "sr-only"
                })
              ]
            })
          }),
          JsxRuntime.jsx(MarketingProfileMembersList$Member$Menu$MenuItem, {
            children: JsxRuntime.jsxs("button", {
              children: [
                "Remove",
                JsxRuntime.jsx("span", {
                  children: `, ` + member.displayName,
                  className: "sr-only"
                })
              ],
              className: "text-zinc-900 w-full flex",
              onClick: param => onRemove()
            })
          })
        ]
      })
    ]
  });
}

let Menu = {
  RemoveMutation: RemoveMutation,
  Fragment: Fragment,
  Menu: undefined,
  MenuItem: MenuItem,
  make: MarketingProfileMembersList$Member$Menu
};

let convertFragment$1 = MarketingProfileMembersList_member_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMembersList_member_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMembersList_member_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MarketingProfileMembersList_member_marketingProfileMember_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMembersList_member_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MarketingProfileMembersList$Member(props) {
  let member = RescriptRelay_Fragment.useFragment(MarketingProfileMembersList_member_marketingProfileMember_graphql.node, convertFragment$1, props.member);
  let match = member.profilePicture;
  return JsxRuntime.jsxs("li", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "h-12 w-12 flex-none rounded-full bg-zinc-50",
            alt: member.displayName + ` profile picture`,
            src: match !== undefined ? match.url : AvatarSrcUrl.place_holder
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: member.displayName,
                className: "font-semibold leading-6 text-zinc-800"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("p", {
                  children: member.title,
                  className: "leading-6 text-zinc-900"
                }),
                className: "flex sm:hidden md:flex lg:hidden"
              })
            ],
            className: "min-w-0 flex-auto"
          })
        ],
        className: "flex gap-x-4 items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("p", {
              children: member.title,
              className: "leading-6 text-zinc-900"
            }),
            className: "hidden sm:flex md:hidden lg:flex"
          }),
          JsxRuntime.jsx(MarketingProfileMembersList$Member$Menu, {
            member: member.fragmentRefs,
            connectionId: props.connectionId
          })
        ],
        className: "flex items-center justify-between gap-x-6 \n            sm:w-1/2 sm:flex-none \n            md:w-auto md:flex \n            lg:w-1/2 lg:flex-none\n            "
      })
    ],
    className: "flex justify-between gap-x-6 py-5"
  }, member.displayName);
}

let Member = {
  Menu: Menu,
  Fragment: Fragment$1,
  make: MarketingProfileMembersList$Member
};

let convertFragment$2 = MarketingProfileMembersList_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMembersList_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMembersList_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MarketingProfileMembersList_teamMarketingProfile_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMembersList_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

let Fragment_getConnectionNodes = MarketingProfileMembersList_teamMarketingProfile_graphql.Utils.getConnectionNodes;

let Fragment$2 = {
  getConnectionNodes: Fragment_getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MarketingProfileMembersList(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(MarketingProfileMembersList_teamMarketingProfile_graphql.node, convertFragment$2, props.marketingProfile);
  let members = Stdlib_Array.filterMap(marketingProfile.members.edges, x => x);
  return JsxRuntime.jsx("ul", {
    children: members.map(param => {
      let member = param.node;
      return JsxRuntime.jsx(MarketingProfileMembersList$Member, {
        member: member.fragmentRefs,
        connectionId: marketingProfile.members.__id
      }, member.id);
    }),
    className: "divide-y divide-zinc-99",
    role: "list"
  });
}

let make = MarketingProfileMembersList;

exports.Member = Member;
exports.Fragment = Fragment$2;
exports.make = make;
/* commitMutation Not a pure module */
